<!-- Start Hero Banner Area -->
<div class="hero-banner-fullscreen">
    <div class="hero-overlay"></div>
    <div class="hero-container">
        <div class="hero-eyebrow">
            <span class="eyebrow-line"></span>
            <span class="eyebrow-text">Welcome to Kitchen Magic</span>
            <span class="eyebrow-line"></span>
        </div>
        <h1 class="hero-main-title">
            Taste the <span class="hero-accent">Magic</span><br>
            Feel the <span class="hero-accent">Love</span> <i class='bx bxs-heart hero-heart'></i>
        </h1>
        <p class="hero-description">
            Authentic South Indian street food crafted with family tradition,<br class="d-none d-md-block">
            the freshest ingredients, and the magic touch of homemade love.
        </p>
        <div class="hero-buttons">
            <a routerLink="/contact" class="btn-order">
                <i class='bx bx-map-pin'></i> Find Us
            </a>
            <a routerLink="/product-menu" class="btn-menu">
                <i class='bx bx-food-menu'></i> Explore Menu
            </a>
        </div>
        <div class="hero-stats">
            <div class="hero-stat">
                <span class="stat-number">50+</span>
                <span class="stat-label">Dishes</span>
            </div>
            <div class="hero-stat-divider"></div>
            <div class="hero-stat">
                <span class="stat-number">4.9★</span>
                <span class="stat-label">Rating</span>
            </div>
            <div class="hero-stat-divider"></div>
            <div class="hero-stat">
                <span class="stat-number">100%</span>
                <span class="stat-label">Fresh</span>
            </div>
        </div>
    </div>
</div>
<!-- End Hero Banner Area -->

<!-- Start Features Section -->
<section class="km-features-section">
    <div class="container">
        <div class="features-wrapper">

            <div class="feature-item">
                <div class="feature-icon-box">
                    <i class='bx bx-leaf'></i>
                </div>
                <div class="feature-content">
                    <h5 class="feature-heading">FRESH INGREDIENTS</h5>
                    <p class="feature-desc">
                        We use only the freshest and finest ingredients.
                    </p>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-icon-box">
                    <i class='bx bx-restaurant'></i>
                </div>
                <div class="feature-content">
                    <h5 class="feature-heading">EXPERT CHEFS</h5>
                    <p class="feature-desc">
                        Our chefs bring years of experience to your plate.
                    </p>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-icon-box">
                    <i class='bx bx-package'></i>
                </div>
                <div class="feature-content">
                    <h5 class="feature-heading">AUTHENTIC TASTE</h5>
                    <p class="feature-desc">
                        Authentic flavors that bring joy to your taste buds.
                    </p>
                </div>
            </div>

            <div class="feature-item">
                <div class="feature-icon-box">
                    <i class='bx bx-award'></i>
                </div>
                <div class="feature-content">
                    <h5 class="feature-heading">BEST QUALITY</h5>
                    <p class="feature-desc">
                        Quality food, great taste and happy customers.
                    </p>
                </div>
            </div>

        </div>
    </div>
</section>
<!-- End Features Section -->